// Cache the public IP to avoid fetching it on every API call
let cachedPublicIP: string | null = null;
let ipFetchPromise: Promise<string> | null = null;

export async function getPublicIP() {
  // Return cached IP if available
  if (cachedPublicIP) {
    return cachedPublicIP;
  }

  // If a fetch is already in progress, return that promise
  if (ipFetchPromise) {
    return ipFetchPromise;
  }

  // Fetch and cache the IP
  ipFetchPromise = (async () => {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      const ip = data.ip as string;
      cachedPublicIP = ip;
      return ip;
    } catch (error) {
      // Reset promise on error so we can retry
      ipFetchPromise = null;
      throw error;
    } finally {
      // Clear the promise after completion (success or failure)
      ipFetchPromise = null;
    }
  })();

  return ipFetchPromise;
}

